<wlm-chips-selector
  [options]="allOptions"
  [selectedValues]="selectedValues"
  [disabled]="disabled"
  [readonlyRows]="readonlyRows"
  (valueChanged)="onValueChanged($event)"
></wlm-chips-selector>
